export default {
  // Page title and navigation
  'pages.other-fee.title': 'Other Fee',
  'pages.other-fee.subtitle': 'Manage community other fee bill generation, payment and inquiry',
  'pages.other-fee.currentSelection': 'Current selection:',
  'pages.other-fee.tabOther': 'Other',
  'pages.other-fee.treeTitle': 'Building Floor House Selection',
  'pages.other-fee.breadcrumb.chargeManagement': 'Charge Management',
  'pages.other-fee.breadcrumb.otherFee': 'Other Fee',

  // Table related
  'pages.other-fee.table.title': 'Other Fee Bill List',
  'pages.other-fee.table.houseInfo': 'House Info',
  'pages.other-fee.table.period': 'Period',
  'pages.other-fee.table.billNo': 'Bill No.',
  'pages.other-fee.table.billName': 'Bill Name',
  'pages.other-fee.table.ownerPhone': 'Owner Phone',
  'pages.other-fee.table.ownerIdCard': 'Owner ID Card',
  'pages.other-fee.table.ownerEmail': 'Owner Email',
  'pages.other-fee.table.finalAmount': 'Final Amount',
  'pages.other-fee.table.approvalStatus': 'Approval Status',
  'pages.other-fee.table.status': 'Payment Status',
  'pages.other-fee.table.paidDate': 'Payment Date',
  'pages.other-fee.table.endTime': 'Due Date',
  'pages.other-fee.table.operation': 'Operation',
  'pages.other-fee.table.view': 'View',
  'pages.other-fee.table.edit': 'Edit',
  'pages.other-fee.table.delete': 'Delete',

  // Action buttons
  'pages.other-fee.action.add': 'New Bill',
  'pages.other-fee.action.submitAudit': 'Submit Audit',
  'pages.other-fee.action.batchDelete': 'Batch Delete',
  'pages.other-fee.action.update': 'Update',
  'pages.other-fee.action.create': 'Create',
  'pages.other-fee.action.cancel': 'Cancel',
  'pages.other-fee.action.close': 'Close',

  // Confirmation dialog
  'pages.other-fee.confirm.delete.title': 'Confirm Delete',
  'pages.other-fee.confirm.delete.content': 'Are you sure to delete the selected {count} records?',
  'pages.other-fee.confirm.delete.okText': 'Confirm',
  'pages.other-fee.confirm.delete.cancelText': 'Cancel',

  // Audit related
  'pages.other-fee.audit.modalTitle': 'Submit Audit',
  'pages.other-fee.audit.auditName': 'Audit Name',
  'pages.other-fee.audit.auditNamePlaceholder': 'Please enter audit name',
  'pages.other-fee.audit.submitRemark': 'Submit Remark',
  'pages.other-fee.audit.submitRemarkPlaceholder': 'Please enter submit remark (optional)',
  'pages.other-fee.audit.selectedBillsTitle': 'Selected Bills List (Total {count})',
  'pages.other-fee.audit.totalAmount': 'Total Amount',
  'pages.other-fee.audit.submit': 'Submit Audit',
  'pages.other-fee.audit.defaultName': '{period} Other Fee Bills ({count})',

  // Form related
  'pages.other-fee.form.editTitle': 'Edit Other Fee Bill',
  'pages.other-fee.form.createTitle': 'New Other Fee Bill',
  'pages.other-fee.form.basicInfo': 'Basic Information',
  'pages.other-fee.form.houseOwnerInfo': 'House & Owner Information',
  'pages.other-fee.form.feeInfo': 'Fee Information',
  'pages.other-fee.form.remarkInfo': 'Remark Information',

  // Form fields
  'pages.other-fee.form.billNo': 'Bill No.',
  'pages.other-fee.form.billNoPlaceholder': 'Please enter bill number',
  'pages.other-fee.form.billNoRequired': 'Please enter bill number',

  'pages.other-fee.form.billName': 'Bill Name',
  'pages.other-fee.form.billNamePlaceholder': 'Please enter bill name',
  'pages.other-fee.form.billNameRequired': 'Please enter bill name',

  'pages.other-fee.form.status': 'Payment Status',
  'pages.other-fee.form.statusPlaceholder': 'Please select payment status',
  'pages.other-fee.form.statusRequired': 'Please select payment status',

  'pages.other-fee.form.period': 'Period',
  'pages.other-fee.form.periodPlaceholder': 'e.g.: 2024-01',
  'pages.other-fee.form.periodRequired': 'Please enter period',

  'pages.other-fee.form.startDate': 'Start Date',
  'pages.other-fee.form.startDatePlaceholder': 'Please select start date',
  'pages.other-fee.form.startDateRequired': 'Please select start date',

  'pages.other-fee.form.endDate': 'End Date',
  'pages.other-fee.form.endDatePlaceholder': 'Please select end date',
  'pages.other-fee.form.endDateRequired': 'Please select end date',

  'pages.other-fee.form.buildingId': 'Building',
  'pages.other-fee.form.buildingIdPlaceholder': 'Please select building',
  'pages.other-fee.form.buildingIdRequired': 'Please select building',

  'pages.other-fee.form.floor': 'Floor',
  'pages.other-fee.form.floorPlaceholder': 'Please select floor',
  'pages.other-fee.form.floorRequired': 'Please select floor',

  'pages.other-fee.form.houseId': 'House',
  'pages.other-fee.form.houseIdPlaceholder': 'Please select house',
  'pages.other-fee.form.houseIdRequired': 'Please select house',

  'pages.other-fee.form.amount': 'Fee Amount',
  'pages.other-fee.form.amountPlaceholder': 'Please enter fee amount',
  'pages.other-fee.form.amountRequired': 'Please enter fee amount',

  'pages.other-fee.form.lateFee': 'Late Fee',
  'pages.other-fee.form.lateFeePlaceholder': 'Please enter late fee',

  'pages.other-fee.form.discountAmount': 'Discount Amount',
  'pages.other-fee.form.discountAmountPlaceholder': 'Please enter discount amount',

  'pages.other-fee.form.finalAmount': 'Final Amount',
  'pages.other-fee.form.finalAmountPlaceholder': 'Auto calculated',
  'pages.other-fee.form.finalAmountRequired': 'Final amount will be auto calculated',

  'pages.other-fee.form.remarks': 'Remarks',
  'pages.other-fee.form.remarksPlaceholder': 'Please enter remarks',
  'pages.other-fee.form.remarksMaxLength': 'Remarks length cannot exceed 500 characters',

  // Status options
  'pages.other-fee.status.unpaid': 'Unpaid',
  'pages.other-fee.status.paid': 'Paid',
  'pages.other-fee.status.overdue': 'Overdue',
  'pages.other-fee.status.partial': 'Partial',
  'pages.other-fee.status.cancelled': 'Cancelled',
  'pages.other-fee.status.draft': 'Draft',
  'pages.other-fee.status.pending': 'Pending',
  'pages.other-fee.status.approved': 'Approved',
  'pages.other-fee.status.rejected': 'Rejected',
  'pages.other-fee.status.notified': 'Notified',

  // Detail modal
  'pages.other-fee.detail.modalTitle': 'Other Fee Bill Detail',
  'pages.other-fee.detail.basicInfo': 'Basic Information',
  'pages.other-fee.detail.houseOwnerInfo': 'House & Owner Information',
  'pages.other-fee.detail.feeInfo': 'Amount Information',
  'pages.other-fee.detail.paymentInfo': 'Payment Information',
  'pages.other-fee.detail.systemInfo': 'System Information',
  'pages.other-fee.detail.auditRecords': 'Audit Records',

  // Detail fields
  'pages.other-fee.detail.billNo': 'Bill No.',
  'pages.other-fee.detail.billName': 'Bill Name',
  'pages.other-fee.detail.period': 'Period',
  'pages.other-fee.detail.status': 'Payment Status',
  'pages.other-fee.detail.approvalStatus': 'Approval Status',
  'pages.other-fee.detail.houseInfo': 'House Info',
  'pages.other-fee.detail.ownerInfo': 'Owner Info',
  'pages.other-fee.detail.ownerIdCard': 'ID Card:',
  'pages.other-fee.detail.ownerEmail': 'Email:',
  'pages.other-fee.detail.ownerId': 'Owner ID:',
  'pages.other-fee.detail.amount': 'Fee Amount',
  'pages.other-fee.detail.lateFee': 'Late Fee',
  'pages.other-fee.detail.discountAmount': 'Discount Amount',
  'pages.other-fee.detail.finalAmount': 'Final Amount',
  'pages.other-fee.detail.paymentMethod': 'Payment Method',
  'pages.other-fee.detail.paymentReference': 'Payment Reference',
  'pages.other-fee.detail.paidDate': 'Payment Date',
  'pages.other-fee.detail.createdTime': 'Created Time',
  'pages.other-fee.detail.updatedTime': 'Updated Time',
  'pages.other-fee.detail.remarks': 'Remarks',

  // Currency unit
  'pages.other-fee.currency.yuan': 'CNY',
  'pages.other-fee.currency.php': '₱',

  // Detail Component Fields
  'pages.other-fee.detail.basicInfo': 'Basic Information',
  'pages.other-fee.detail.billNo': 'Bill Number',
  'pages.other-fee.detail.billName': 'Bill Name',
  'pages.other-fee.detail.period': 'Period',
  'pages.other-fee.detail.paymentStatus': 'Payment Status',
  'pages.other-fee.detail.approvalStatus': 'Approval Status',
  'pages.other-fee.detail.startDate': 'Start Date',
  'pages.other-fee.detail.endDate': 'End Date',
  'pages.other-fee.detail.houseOwnerInfo': 'House & Owner Information',
  'pages.other-fee.detail.houseInfo': 'House Information',
  'pages.other-fee.detail.ownerInfo': 'Owner Information',
  'pages.other-fee.detail.amountInfo': 'Amount Information',
  'pages.other-fee.detail.baseAmount': 'Base Amount',
  'pages.other-fee.detail.lateFee': 'Late Fee',
  'pages.other-fee.detail.discountAmount': 'Discount Amount',
  'pages.other-fee.detail.finalAmount': 'Final Amount',
  'pages.other-fee.detail.paymentInfo': 'Payment Information',
  'pages.other-fee.detail.paymentMethod': 'Payment Method',
  'pages.other-fee.detail.paymentReference': 'Payment Reference',
  'pages.other-fee.detail.dueDate': 'Due Date',
  'pages.other-fee.detail.paymentDate': 'Payment Date',
  'pages.other-fee.detail.systemInfo': 'System Information',
  'pages.other-fee.detail.createdTime': 'Created Time',
  'pages.other-fee.detail.updatedTime': 'Updated Time',
  'pages.other-fee.detail.remarks': 'Remarks',

  // Message prompts
  'pages.other-fee.message.selectRecordsToDelete': 'Please select records to delete',
  'pages.other-fee.message.selectRecordsToAudit': 'Please select bills to submit for audit',
  'pages.other-fee.message.deleteSuccess': 'Delete successful',
  'pages.other-fee.message.deleteFailed': 'Delete failed',
  'pages.other-fee.message.auditSubmitSuccess': 'Audit submission successful',
  'pages.other-fee.message.auditSubmitFailed': 'Audit submission failed',
  'pages.other-fee.message.updateSuccess': 'Update successful',
  'pages.other-fee.message.createSuccess': 'Create successful',
  'pages.other-fee.message.submitFailed': 'Submit failed',
  'pages.other-fee.message.batchDeleteSuccess': 'Batch delete successful',
  'pages.other-fee.message.batchDeleteFailed': 'Batch delete failed',

  // Pagination related
  'pages.other-fee.pagination.showTotal': 'Items {range0}-{range1} of {total}',

  // Loading status
  'pages.other-fee.loading.auditRecords': 'Loading...',
  'pages.other-fee.empty.auditRecords': 'No audit records',

  // Error logs
  'pages.other-fee.error.loadRecentMonths': 'Failed to load recent 6 months:',
  'pages.other-fee.error.loadTreeData': 'Failed to load building floor house data:',
  'pages.other-fee.error.loadTableData': 'Failed to get other fee bill list:',
  'pages.other-fee.error.loadStatusOptions': 'Failed to load status options:',
  'pages.other-fee.error.loadApprovalStatusOptions': 'Failed to load approval status options:',
  'pages.other-fee.error.loadBuildings': 'Failed to load buildings:',
  'pages.other-fee.error.loadFloors': 'Failed to load floors:',
  'pages.other-fee.error.loadHouses': 'Failed to load houses:',
  'pages.other-fee.error.generateOrderNo': 'Failed to generate order number:',
  'pages.other-fee.error.getAuditRecords': 'Failed to get audit records:',

  // Popconfirm related
  'pages.other-fee.popconfirm.deleteTitle': 'Are you sure to delete this record?',
  'pages.other-fee.popconfirm.okText': 'Confirm',
  'pages.other-fee.popconfirm.cancelText': 'Cancel',
};
